var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2762_17397",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.84321H2.88963L2.88963 10.5953H4.81605V3.84321H7.70569L3.85284 0L0 3.84321Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2762_17397)",
    transform: "rotate(180 4 5.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -7,
    width: 24,
    height: 24,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscSort);
export default __webpack_public_path__ + "static/media/asc-sort.22c7b6434a7c36802274564001ed6342.svg";
export { ForwardRef as ReactComponent };